export enum Roles {
  AGMSAdmin = "Global Admin",
  PartnerAdmin = "Partner Admin",
  CompanyAdmin = "Company Administrator",
  SiteAdmin = "Site Administrator",
  GroupAdmin = "Group Administrator",
  SiteAudit = "Site Auditor",
  GroupAudit = "Group Auditor",
}

export enum Rules {
  AGMSGroupSelect = "agms_group_select",
  AGMSTemplateSelect = "agms_template_select",
  AGMSTemplateType2Select = "agms_template_type2_select",
}
